import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotSection from './components/HotSection';
import NewSection from './components/NewSection';
import RankingSection from './components/RankingSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotSection />
        <NewSection />
        <RankingSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}